import { Component, HostBinding, ViewEncapsulation, OnDestroy } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { RouterOutlet } from '@angular/router';

import amWithTextIcon from '../shared/svg/am_with_text.svg';
import mdCloseIcon from '../shared/svg/md/outline-close-24px.svg';

const LANGUAGE_OPTIONS: Record<string, string | undefined> = {
	en: 'English',
	es: 'Español',
	fr: 'Français',
	it: 'Italiano',
	de: 'Deutsch'
};

function resolveLang(lang: string | undefined) {
	if (lang && LANGUAGE_OPTIONS[lang]) {
		return lang;
	}
	return 'en';
}

@Component({
	standalone: true,
	selector: 'copo-app',
	templateUrl: './root.component.html',
	encapsulation: ViewEncapsulation.None,
	imports: [RouterOutlet]
})
export class RootComponent implements OnDestroy {
	@HostBinding('class.full-height') fullHeight = true;

	translateSub: Subscription;
	constructor(
		readonly sanitizer: DomSanitizer,
		private readonly iconRegistry: MatIconRegistry,
		private readonly translate: TranslateService
	) {
		this.translate.setDefaultLang('en');
		const browserLang = resolveLang(this.translate.getBrowserLang());
		const storedLanguage = localStorage.getItem('language');
		const lang = storedLanguage || browserLang;
		this.translateSub = this.translate.use(lang).subscribe({
			next() {
				console.info('language changed', lang);
			}
		});
		document.documentElement.lang = browserLang;

		this.iconRegistry
			.addSvgIconLiteral('am_with_text', sanitizer.bypassSecurityTrustHtml(amWithTextIcon))
			.addSvgIconLiteralInNamespace('md', 'close', sanitizer.bypassSecurityTrustHtml(mdCloseIcon));
	}

	ngOnDestroy() {
		this.translateSub.unsubscribe();
	}
}
